import { useAppSelector } from '@/hooks/store'
import { mapCurrentSectorSelector } from '@/store/mapSlice'
import { ExpandedText } from '../ExpandedText'

export function SectorExpandableText() {
  const currentSector = useAppSelector(mapCurrentSectorSelector)

  if (!currentSector?.header.description) {
    return null
  }

  return (
    <ExpandedText
      clamp={2}
      containerClassName="p-3 border-b border-solid border-gray-200"
      text={currentSector.header.description}
    />
  )
}
